import { getCookie } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import abtestService from '@webServices/abtest.service';
import Events from '@shared/easyfy.events/easyfy.eventhandler';
import {
  IEasyfyEvent,
  EasyfyEventData
} from '@shared/easyfy.events/easyfy.eventdata';
import { MedsEventNames } from './eventMappers/dataMapper.ga4';

namespace Meds.Modules {
  @invoke
  export class MedsABTest {

    onInit() {
      // get or set abcookie
      this.SetABCookie();
    }

    private SetABCookie = async () => {
      // don't set cookie if setabtest not is configured or if cookie already is set
      if (
        EasyfyEventData.ConsumesEvent('ga4', MedsEventNames.SetABTest) === false
      ) {
        return;
      }

      let cookieValue = '';

      if (document.cookie.indexOf('ab_meds=') === -1) {
        abtestService
          .GetABCookie()
          .then((response) => {
            if (response.status === 200 && response.data.cookieValue != null) {
              cookieValue = response.data.cookieValue;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const abMedsCookieValue = getCookie('ab_meds');
        if (abMedsCookieValue) {
          cookieValue = atob(decodeURIComponent(abMedsCookieValue));
        }
      }

      const gaEvent: IEasyfyEvent = {
        eventName: MedsEventNames.SetABTest,
        data: {
          set: 'user_properties',
          abTest: cookieValue
        }
      };
      setTimeout(() => {
        Events.EasyfyEventHandler.RunEvent(gaEvent);
      }, 1000);
    };
  }
}
